import { Expose, Type } from 'class-transformer'

import { ASN } from './ASN'
import { Product } from './Product'
import { Sku } from './Sku'

export class ASNExpectedUnit {
  get guid() {
    return this.sku?.guid
  }

  @Type(() => ASN)
  asn?: ASN

  @Type(() => Product)
  product?: Product

  @Type(() => Sku)
  sku?: Sku

  @Expose({ name: 'num_units' })
  numUnits: number = 0

  @Expose({ name: 'num_received' })
  numReceived: number = 0

  shortage?: number
}
